export class NewUserMessageInformation {
    constructor() {
        this.messageText = '';
    }
    subject: string;
    messageText: string;
    users: string[];
}